import { getCO2Scope3Auswahl } from '../../dateneingabe/functions/getCO2Scope3Auswahl';
import { getSelectableEnergiedatenEntities, getEnergiedatenAuswahl } from '../../dateneingabe/functions/getEnergiedatenStructure';
import { getFormRequired } from '../../dateneingabe/functions/getFormRequired';
import { IDs } from '../../../helpers/IDs';
import { isFieldHidden } from '../../dateneingabe/functions/isFieldHidden';
import { removeErrorLevelAddOn } from '../../../core/forms/helpers/errorLevelTools';
import { validateFieldUniversal } from '../../../bereiche/dateneingabe/functions/validateField';
import { WFormData } from '../../../core/forms/WFormData';

export class Validierung {

    protected additionalFields: string[];
    protected data: any;
    protected energietraeger: string;
    protected entities: any;
    protected jahr: number;
    protected key: string;
    protected standortTid: number;
    protected types: string[];
    protected validation: any;

    constructor(data: any, standortTid: number, entities: any, key: string, types?: string[], energietraeger?: string, jahr?: number, additionalFields?: string[]) {
        this.additionalFields = additionalFields || [];
        this.data = data;
        this.energietraeger = energietraeger;
        this.entities = entities;
        this.jahr = jahr;
        this.key = key || null;
        this.standortTid = standortTid;
        this.types = types || [];
        this.validation = {};
        (entities || []).forEach((entity: any) => entity.entity ? this.checkEntity(entity.entity) : null);
    }

    public getData(): any {
        return this.validation;
    }

    protected checkEntity(entity: string): void {
        const data: any[] = ((this.data || {})[entity] || []).filter((row: any) =>
            (!this.standortTid || row.standort_tid_orig === this.standortTid)
            && (!this.jahr || (typeof row.jahr !== 'undefined' && row.jahr === this.jahr))
            && !(row.monat || null)
            && !(row.parent_tid || null)
            && (!this.energietraeger || row.energietraeger_tid === this.energietraeger)
            && (!entity.startsWith('co2_scope3_')
                ? !(getSelectableEnergiedatenEntities().indexOf(entity) !== -1 && getEnergiedatenAuswahl(this.data, row.standort_tid_orig, +row[this.key]).indexOf(entity) === -1)
                : (getCO2Scope3Auswahl(this.data, { tid: row.standort_tid_orig }, +row[this.key], +row[this.key]) || []).indexOf(entity.replace('co2_scope3_', '')) !== -1
            )
            && !(row.bemerkung || '').toString().includes('DS korrekt')
        );

        data.forEach((item: any) => {
            const additionalFields: any = {};
            const FormData: any = new WFormData();
            const required: any = getFormRequired(IDs.MOD_ETOOL, entity, item, this.data);
            const row: any = {};
            const validation: any = {};

            Object.keys(item).forEach((index: string) => {
                const index2: string = index.endsWith('_orig') ? index.replace('_orig', '') : index;
                row[index2] = item[index];

                if (this.additionalFields.indexOf(index2) !== -1 && row[index2]) {
                    additionalFields[`_${index2}`] = row[index2];
                }
            });
            FormData.setBundle(this.data[`${entity}_bundle`] || {});
            FormData.setAllValues(row);
            const values: any = FormData.values || {};

            Object.keys(row).forEach((key: string) => {
                const isException: boolean = (entity === IDs.ENT_BETRIEBSDATEN);
                    // || (
                    //     entity === IDs.ENT_ENERGIEDATEN_KRAFTSTOFFE && key === 'kosten' && values.kosten === null
                    //     && values.verbrauch !== null
                    // )
                    // || (
                    //     entity === IDs.ENT_ENERGIEDATEN_WASSER && key === 'kosten_bezug' && values.kosten_bezug === null
                    //     && values.fremdbezug !== null
                    // );
                let category: string = null;
                let inputOnly: boolean = false;
                let type: string = null;
                let field: string = validateFieldUniversal(
                    entity, key, row[key], FormData, null, this.data, (info: any) => {
                        category = (info || {}).category || null;
                        inputOnly = !!(info || {}).inputOnly;
                        type = (info || {}).type || null;
                    }
                );

                if (isFieldHidden(entity, key, values, this.data) || inputOnly) {
                    return;
                }

                if (
                    ((typeof field === 'undefined' || field === null || field === '') || isException)
                    && (
                        (typeof row[key] === 'undefined' || row[key] === null || row[key] === ''
                            || ((required[key] || {}).type === 'select' && values[key] == 0)
                        )
                        && Object.keys(required).indexOf(key) !== -1
                    )
                ) {
                    field = `Bitte Feld '${required[key].name || ''}' ausfüllen`;
                    type = isException ? 'warning' : 'error';
                }

                if (
                    (typeof field === 'undefined' || field === null || field === '')
                    || (this.types.length && this.types.indexOf(type) === -1)
                ) {
                    return;
                }
                validation[key] = {
                    text: (field || '').toString().split('\n').map((line: string) => line),
                    ...(category && { category }),
                    ...(type && { type }),
                    ...additionalFields
                };

                if (!this.validation._items) {
                    this.validation._items = [];
                }
                this.validation._items.push({
                    entity,
                    key,
                    tid: values.tid || null,
                    ...(row.jahr && { jahr: row.jahr }),
                    ...(row.standort_tid && { standort_tid: row.standort_tid }),
                    ...validation[key],
                    text: (validation[key].text || []).map((value: string) => removeErrorLevelAddOn(value))
                });
                this.setData({
                    entity,
                    [this.key]: row[this.key] || null,
                    tid: values.tid || null,
                    fields: validation
                });
            });
        });
    }

    protected setData(data: any): void {
        const entity: string = data.entity || null;
        const fields: any = data.fields || {};
        const key: number = data[this.key] || null;
        const tid: number = +data.tid || null;
        const validation: any = this.validation || {};

        if (!key || !entity || !tid || !Object.keys(fields).length) {
            return;
        }

        if (!validation[key]) {
            validation[key] = { [entity]: {} };
        }

        if (!validation[key][entity]) {
            validation[key][entity] = {};
        }

        if (!validation[key][entity][tid]) {
            validation[key][entity][tid] = {};
        }
        validation[key][entity][tid] = fields;
        this.validation = validation;
    }
}
